<template>
  <footer class="sticky-footer bg-white">
    <div class="container my-auto">
      <div class="copyright text-center my-auto">
        <span>Copyright &copy; VSquad 2020</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>
